import { buttonClickHandler } from "./button-click-handler";
import TextMessage from "../text-message/text-message";
import ButtonIcon from "../cards/button-icon";
// Utility function to lighten a color
function lightenColor(color, percent) {
  let num = parseInt(color.replace("#", ""), 16),
      amt = Math.round(2.55 * percent),
      R = (num >> 16) + amt,
      G = (num >> 8 & 0x00FF) + amt,
      B = (num & 0x0000FF) + amt;
  
  return "#" + (
    0x1000000 +
    (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
    (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
    (B < 255 ? B < 1 ? 0 : B : 255)
  ).toString(16).slice(1).toUpperCase();
}

export default function Buttons(props) {
  const { message = {}, onInvokeAction } = props;
  const onClick = buttonClickHandler(onInvokeAction);

  // Determine dynamic styles
  const defaultBgColor = props.chatBotSetting?.headerBackgroundColor || '#f0f0f0';
  const defaultTextColor = props.chatBotSetting?.headerTextColor || '#ffff';
  const hoverBgColor = defaultTextColor;
  const hoverTextColor = defaultBgColor;

  // Create a lighter shade of the header background color
  const lighterBorderColor = lightenColor(defaultBgColor, 35); // 20% lighter
  const displayText = message?.displayText || "".trim()
  return (
    <div className='w-full my-2'>
      <div className='message-text'>
        {message.displayText &&
          <TextMessage message={displayText} senderType={props.senderType} />
        }
        <div className='bot-option-wrap my-4 flex items-center flex-wrap gap-2'>
          {message?.buttons.map((option, index) => (
            <button
              key={index}
              className='px-4 py-4 inline-block rounded-lg text-sm font-medium transition-all'
              style={{
                backgroundColor: hoverBgColor,
                color: hoverTextColor,
                borderColor: lighterBorderColor,
                borderWidth: '1px', // Border width for the button
                borderStyle: 'solid', // Border style
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = defaultBgColor;
                e.currentTarget.style.color = defaultTextColor;
                e.currentTarget.style.borderColor = defaultTextColor; // Darker border on hover
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = hoverBgColor;
                e.currentTarget.style.color = hoverTextColor;
                e.currentTarget.style.borderColor = lighterBorderColor; // Revert to lighter border
              }}
              onClick={async () => { await onClick(option.payload, option); }}
            >
              <ButtonIcon icon={option?.icon} alt={option?.title} />
              {option.title}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
